import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner, Alert } from 'react-bootstrap';
import mammoth from 'mammoth';

const DocxViewerModal = ({ show, onHide, docxUrl, docName }) => {
    const [htmlContent, setHtmlContent] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (show && docxUrl) {
            setLoading(true);
            setError('');
            fetch(docxUrl)
                .then(res => res.arrayBuffer())
                .then(arrayBuffer => mammoth.convertToHtml({ arrayBuffer }))
                .then(result => {
                    setHtmlContent(result.value);
                    setLoading(false);
                })
                .catch(() => {
                    setError('Erro ao converter o arquivo DOC/DOCX');
                    setLoading(false);
                });
        } else {
            setHtmlContent('');
        }
    }, [show, docxUrl]);

    return (
        <Modal show={show} onHide={onHide} size="xl" centered dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title>Visualizando: {docName}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '80vh', overflowY: 'auto' }}>
                {loading && <Spinner animation="border" />}
                {error && <Alert variant="danger">{error}</Alert>}
                {!loading && !error && (
                    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DocxViewerModal; 